import http from '../support/HttpService';
import {buildNuevoTicket} from "../dto/TicketsDTOBuilder";
import {buildMostrarCaptchaResponse} from "../dto/DisponibilidadDTOBuilder";

const REACT_APP_TICKET = process.env.REACT_APP_TICKET;
const REACT_APP_TICKET_MOSTRAR_CAPTCHA = process.env.REACT_APP_TICKET_MOSTRAR_CAPTCHA || `${REACT_APP_TICKET}/mostrarCaptcha`;

const TicketsService = {

    generarTicket: async function(ticket, tipoOperacion, captchaResponse) {
        try {

            const formData = buildNuevoTicket(ticket, tipoOperacion, captchaResponse);
            // Sin Content-Type manual: axios debe enviar boundary en multipart/form-data
            const response = await http.post(REACT_APP_TICKET, formData);

            return response.data;
        } catch (error) {
            console.error("Error generando ticket", error);
            const mensaje =
                error instanceof Error && error.message
                    ? error.message
                    : "Se produjo un error al procesar su solicitud. Por favor inténtelo nuevamente más tarde.";
            return {
                respuestaOK: false,
                mensajeRespuesta: mensaje,
            };
        }
    },

    mostrarCaptcha: async function() {
        try {
            const response = await http.get(REACT_APP_TICKET_MOSTRAR_CAPTCHA);
            return buildMostrarCaptchaResponse(response.data);
        } catch (error) {
            console.error("Error consultando visibilidad de captcha para tickets", error);
        }
    },

}
export default TicketsService;
